(function () {

    'use strict';
    angular.module('app')
        .controller('wizardController',
            [
                '$location',
                '$routeParams',
                '$timeout',
                '$rootScope',
                'wizardService',
                wizardController
            ]
        );

    function wizardController($location, $routeParams, $timeout, $rootScope, wizardService) {
       
        $rootScope.showLogo = true;
        var vm = this;
        vm.clientToken = $routeParams.ct;
        vm.waiting = true;
        $rootScope.showLogo = true;

        /*
        vm.response = {
            "products": [{ "product": "GatorLeads", "shortName": "Leads", "uniqueId": "sample@leasoftware.net" }],
            "client": "Gator.Leads",
            "clientDetails": 0,
            "uniqueId": "",
            "requestedUrl": null,
            "loginUrl":
                "http://local-signon.communigator.co.uk/login?ct=1HjkARTWrO6wWuE4H0YC%2fHnD87Z7BKLUTjF8T9AfllIimnK3HkCf3WBIYr7%2fgmMM76ff6PX2P6YHWhqCSqAKdulUci6tMTqQXODLHTR1N94%3d"
        };
         
        //vm.waiting = false;

        return;
        */

        wizardService.attach().then(function(response) {
                vm.response = response;
                vm.waiting = false;
            },
            function(response) {

            }
        );


    }
})();